export const pixToRem = (size: number) => `${size / 13}rem`;
